import { Injectable } from '@angular/core';
import { QuestionRuleType } from '../models/question-rules/QuestionRuleType';

@Injectable({
  providedIn: 'root'
})
export class QuestionRuleTypeService {

  public types: QuestionRuleType[];
  constructor() { }

  getId(type: string): number {
    return this.types.find(s => s.type == type).questionRuleTypeId;
  }

  getType(questionRuleTypeId: number): string {
    return this.types.find(s => s.questionRuleTypeId == questionRuleTypeId).type;
  }
}
